import axios from "axios";
import { errorMessage, tokenExpired, errorAlert } from "@/api/errorMessages";
import io from "socket.io-client";

export default {
  namespaced: true,
  state: {
    autoassignerData: null,
    dataAutoassignerSocket: null,
    notificationAutoassigner: null
  },
  getters: {
    showAutoassignerData(state) {
      return state.autoassignerData;
    },
    showNotificationAutoassigner(state) {
      return state.notificationAutoassigner;
    }
  },
  mutations: {
    // SET AUTOASSIGNER DATA
    setAutoassignerData(state, AutoassignerData) {
      state.autoassignerData = AutoassignerData;
    },
    // OPEN WEBSOCKET AUTOASSIGNER
    setDataAutoassignerSocketListener(state) {
      state.dataAutoassignerSocket.on("autoassigner_notification", function(
        data
      ) {
        state.notificationAutoassigner = data;
      });
    },
    // CLOSE WEBSOCKET AUTOASSIGNER
    closeDataUsersSocketListener(state) {
      state.dataAutoassignerSocket.disconnect();
    }
  },
  actions: {
    async getAutoassignerInfo({ commit }, params) {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE + `/api/autoassigner/get-all/`,
          {
            params: params
          }
        );
        commit("setAutoassignerData", response.data);
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    async updateAutoassigner(__, payload) {
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/autoassigner/${payload.autoassignerId}/`,
          payload.body
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          if (err.response?.data?.detail[0].msg) {
            errorAlert(
              "There is something wrong",
              err.response?.data?.detail[0].msg
            );
          } else {
            errorMessage();
          }
        }
        return err.response;
      }
    },
    // START WEBSOCKET AUTOASSIGNER
    notificationAutoassignerSocket({ commit, state }) {
      let token = localStorage.getItem("charlie-otr-token");
      const baseDomain = process.env.VUE_APP_BACK_ROUTE;
      const dataAutoassignerRoute = baseDomain + "/" + "autoassigner";
      state.dataAutoassignerSocket = io(dataAutoassignerRoute, {
        path: "/sio/socket.io/",
        transports: ["websocket"],
        query: {
          Authorization: `Bearer ${token}`
        }
      });
      commit("setDataAutoassignerSocketListener");
    }
  }
};
